export class PromiseHelper<T> {

    private p: Promise<T> | undefined;

    public newPromise(promise: Promise<T>,
        t: (result: any) => any,
        c?: (error: any) => any
    ) {
        this.p = promise;
        this.p
            .then(x => {
                if (this.p) {
                    this.p = undefined;
                    t(x);
                }
            })
            .catch(x => {
                console.log(`PromiseHelper caught error ${x.message}, ${x.detail}`);
                if (this.p) {
                    this.p = undefined;
                    if (c) {
                        c(x);
                    } else {
                        alert('Unhandled error occurred in promiseHelper');
                    }
                }
            });

    }

    public clearPromise() {
        this.p = undefined;
    }

}